<template>
  <div id="search">
    <search-basic v-if="isBasic"></search-basic>
    <search-fednet v-if="isFednet"></search-fednet>
  </div>
</template>

<script>
import SearchBasic from './Basic.vue'
import SearchFednet from './Fednet.vue'
import { mapState } from 'vuex'
export default {
  components: {
    SearchBasic,
    SearchFednet
  },
  data () {
    return {
      isFednet: false,
      isBasic: false
    }
  },
  watch: {
    iframeData: {
      handler: function (value) {
        console.log(value)

        if (!value || !value.objectId) return false
        if (value.planId) {
          this.isFednet = true
          this.$emit('titlechange', 'Choose a plan')
        } else {
          this.isBasic = true
          this.$emit('titlechange', 'Event Payment')
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapState({
      // emailid: state => state.userInfo.email,
      iframeData: 'iframeData'
    })
  }
}
</script>

<style lang="less" scoped>
  #search {
    height: 100%;
    min-width: 240px;
    min-height: 300px;
  }
</style>
